// extracted by mini-css-extract-plugin
export default {"mainContainer":"ContactAdministrator_mainContainer__ID27n","text":"ContactAdministrator_text__X2-+5"};